export default __webpack_public_path__ + "static/media/VET.47827162.png";